import { render } from "./QuestionnaireComponent.vue?vue&type=template&id=04e5bd73&scoped=true&ts=true"
import script from "./QuestionnaireComponent.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireComponent.vue?vue&type=script&lang=ts"

import "./QuestionnaireComponent.vue?vue&type=style&index=0&id=04e5bd73&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e5bd73"]])

export default __exports__